var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00012 10.2001L2.50012 6.70005C2.11012 6.31005 1.49012 6.31005 1.10012 6.70005C0.710117 7.09005 0.710117 7.71005 1.10012 8.10005L5.29012 12.2901C5.68012 12.6801 6.31012 12.6801 6.70012 12.2901L17.3001 1.70005C17.6901 1.31005 17.6901 0.690053 17.3001 0.300053C16.9101 -0.0899469 16.2901 -0.0899469 15.9001 0.300053L6.00012 10.2001Z",
    fill: "#329D9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.bc34c8ecb179e8b9790e678e3b4d6260.svg";
export { ForwardRef as ReactComponent };